<template>
  <div>
    <el-table :data="records">
      <el-table-column prop="userId" label="员工ID"></el-table-column>
      <el-table-column prop="name" label="员工姓名"></el-table-column>
      <el-table-column prop="kpi" label="员工kpi"></el-table-column>

      <el-table-column
        prop="nowStaffFrozenAmount"
        label="当前员工冻结"
      ></el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | moment }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'foundationRecordList',
  data() {
    return {};
  },
  computed: {
    ...mapState('kpi', ['totalCount', 'pagination', 'records']),
    ...mapGetters('kpi', ['recordList'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapMutations('kpi', ['setpage']),
    handleCurrentChange(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped></style>
